export default class FormError {
  public count = 0;
  public heading = "";
  public errors: string[] = [];
  public targets: string[] = [];
}
